import { render, staticRenderFns } from "./RsaPazienteSocioRiabilitativoProfiloIntegrativoEditComponent.vue?vue&type=template&id=70fda700"
import script from "./RsaPazienteSocioRiabilitativoProfiloIntegrativoEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSocioRiabilitativoProfiloIntegrativoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports